export default "__VITE_ASSET__DgfV8Weq__"